export enum SortState {
  default = "DEFAULT",
  asc = "ASC",
  desc = "DESC",
}

export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50];
